import { render, staticRenderFns } from "./CampsPage.vue?vue&type=template&id=c0896952&lang=pug&"
import script from "./CampsPage.vue?vue&type=script&lang=js&"
export * from "./CampsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports